module.exports = __webpack_public_path__ + "media/images/icons/filled/apple-ee96ffef5045d0de703e49beae7112ef.svg";